import { Component, Input, OnInit, Output, EventEmitter, DoCheck, OnChanges, SimpleChanges, IterableDiffers } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { BadgeSelectorComponent } from 'src/app/reusables/badge-selector/badge-selector.component';
import { cloneDeep, isEqual } from 'lodash';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-configure-rewards-milestone',
  templateUrl: './configure-rewards-milestone.component.html',
  styleUrls: ['./configure-rewards-milestone.component.scss']
})
export class ConfigureRewardsMilestoneComponent implements OnInit, DoCheck, OnChanges {
  @Input() step: number;
  @Input() componentOptions: any;
  @Input() milestoneQty: string;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  iterableDiffer;
  showRemove = [];
  reverse: boolean = false;
  editing: boolean;
  rewardType: any;
  rewardValue: number;
  showBadgeSelector: boolean;
  selectedReward: any;
  milestoneRewards: any;
  oldMilestoneRewards: any = null;
  consideredComplete: boolean = false;
  isCxone = false;

  constructor(
    private gamesService: GamesService,
    private modalService: NgbModal,
    private iterableDiffers: IterableDiffers,
    private metricPipe: GenericMetricFormatterPipe,
    public cvConfigurationService: CvConfigurationService,
    private cvLocalizationService: CVLocalizationService,
  ) { 
    this.gs = this.gamesService.data;
    this.iterableDiffer = this.iterableDiffers.find([]).create(null);
  }

  ngOnInit(): void {
      this.milestoneRewards = (this.gs.modified.item.MilestoneRewards != undefined || this.gs.modified.item.MilestoneRewards != null) ? this.gs.modified.item.MilestoneRewards : [];
      this.AddIndex();
      this.isCxone = this.cvConfigurationService.isCxOne;
  }

  ngDoCheck(): void{
    let changes = this.iterableDiffer.diff(this.gs.modified.item.SelectedMetrics);

    if(changes){
      this._checkForDownwardMetric();
    }

    if (this.gs.modified.item.MilestoneRewards != undefined && this.gs.modified.item.MilestoneRewards != null && this.gs.modified.item.MilestoneRewards != this.oldMilestoneRewards){
      this.oldMilestoneRewards = this.gs.modified.item.MilestoneRewards
      this.gs.modified.item.MilestoneRewards = cloneDeep(this.milestoneRewards);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
     if (changes.milestoneQty) {
       const isEdition = changes.milestoneQty.currentValue != null && changes.milestoneQty.previousValue == null
       if (this.gs.modified.item.underlyingRule.RuleID == 0 || changes.milestoneQty.previousValue != changes.milestoneQty.currentValue && !isEdition) {
         this.milestoneRewards = (this.gs.modified.item.MilestoneRewards != undefined || this.gs.modified.item.MilestoneRewards != null) ? this.gs.modified.item.MilestoneRewards : [];
         this.createRewards();
       } else {
         this.milestoneRewards = cloneDeep(this.gs.modified.item.MilestoneRewards);
         this.AddIndex();
       }
      
     this._checkForDownwardMetric()
    }
  }

  //Template to create Reward
  _newMilestoneRewardTemplate (type: number): any {
    return {
      Coins: this._newRewardTemplate(this.gs.rewardOptions.Coins),
      XP: this._newRewardTemplate(this.gs.rewardOptions.XP),
      Currency: this._newRewardTemplate(this.gs.rewardOptions.Currency),
      Badge: this._newRewardTemplate(this.gs.rewardOptions.Badge),
      Target: {
        Val1: null,
        Val2: null
      },
      ComparisonType: type
    }
  }

  _newRewardTemplate (type: number): any {
    return {
      editing: false,
      rewardType: type,
      rewardValue: 0
    }
  }

  _checkForDownwardMetric(): void {
    if (this.milestoneRewards != null && this.milestoneRewards.length > 0 && this.gs.modified.item.SelectedMetrics != null && this.gs.modified.item.SelectedMetrics.length > 0) {
      if (this.gs.modified.item.SelectedMetrics[0].direction == "0") {
        this.milestoneRewards[0].ComparisonType = "2"; //Less than since the metric direction is down
      }
      else if (this.gs.modified.item.SelectedMetrics[0].direction == "1") {
        this.milestoneRewards[0].ComparisonType = "1"; //Greater than since the metric direction is up
      }
    }
  }

  createRewards (): void {
    //First one always will be 1 o 2 
    if ((this.milestoneRewards.length > 0 && this.milestoneRewards.length != this.gs.modified.item.MilestoneDetails.MilestoneQty) || (this.milestoneRewards.length > 0 && isEqual(this.gs.modified._old, {}))) {
      this.milestoneRewards = [];
      this.milestoneRewards[0] = this.gs.modified.item.MilestoneRewards[0];
      for (var i = 1; i < this.gs.modified.item.MilestoneDetails.MilestoneQty; i++) {
        this.milestoneRewards[i] = (this.gs.modified.item.MilestoneRewards[i]) ? this.gs.modified.item.MilestoneRewards[i] : this._newMilestoneRewardTemplate(3);
      }
      this.gs.modified.item.MilestoneRewards = cloneDeep(this.milestoneRewards);
    }
    else {
      this.milestoneRewards[0] = this._newMilestoneRewardTemplate(1)
      for (var i = 1; i < this.gs.modified.item.MilestoneDetails.MilestoneQty; i++) {
          this.milestoneRewards[i] = this._newMilestoneRewardTemplate(3)
      }
    }

    this.AddIndex();
  }

  AddIndex (): void {
    if (this.milestoneRewards.length == 0) return;
    var counter = this.milestoneRewards.length;
    for (var i = 0; i < this.milestoneRewards.length; i++) {
      this.milestoneRewards[i].Index = counter;
      counter--;
    }
  }

  popBadgeSelector (selectedReward: any): void {
    this.showBadgeSelector = true;
    this.selectedReward = selectedReward;

    const modalRef = this.modalService.open(BadgeSelectorComponent, {
      animation: true,
      backdropClass: 'stopScrolling',
      size: 'md-lg modal-dialog-noborder-when-loading modal-dialog-centered'
    });

    //Sending input value
    modalRef.componentInstance.header = this.gamesService.getLocalizedMessage("Select_Badge", "Select your badge");
    modalRef.componentInstance.showWhen = this.showBadgeSelector;
    modalRef.componentInstance.showCustomBadge = !this.isCxone;

    //Catching event answer
    modalRef.componentInstance.onBadgeSelected.subscribe(result => {
      this.selectedReward.Badge.rewardValue = result;
      modalRef.close();
    });
  }

  recalculateVal2Fields (): void {
    var step = -0.01;

    //If time metric, increment by whole number values (seconds)
    if (this.gs.modified.item.SelectedMetrics != null && this.gs.modified.item.SelectedMetrics.length > 0 && this.gs.modified.item.SelectedMetrics[0].conversionType == '4') {
      step = -1;
    }

    //If percent metrics, increment by 4 decimal places (0.0001) since percents convert before getting here and a granularity of 0.01 effectively increments by whole percents.
    if (this.gs.modified.item.SelectedMetrics != null && this.gs.modified.item.SelectedMetrics.length > 0 && this.gs.modified.item.SelectedMetrics[0].conversionType == '5') {
      step = -0.0001;
    }

    if (this.milestoneRewards != null && this.milestoneRewards.length > 0 && this.milestoneRewards[0].ComparisonType == "2") {
      step *= -1;
    }

    for (var i = 1; i < this.milestoneRewards.length; i++) {
      var v1 = parseFloat(this.milestoneRewards[i - 1].Target.Val1);
      if (v1 != null && !isNaN(v1)) {
        this.milestoneRewards[i].Target.Val2 = v1 + step;
      }
    }
    this.gs.modified.item.MilestoneRewards = cloneDeep(this.milestoneRewards);
  }

  formatFieldOnBlur (index: number) {
    let setTo = cloneDeep(this.milestoneRewards[index].Target.Val1);
    setTimeout(() => {
      //Set it to something it isn't (causing the $format chain to run)
      this.milestoneRewards[index].Target.Val1 = this.milestoneRewards[index].Target.Val1 == 1 ? 0 : 1;
      setTimeout(() => {
        //Set it back to the value the user entered, thus causing the $format chain to run
        this.milestoneRewards[index].Target.Val1 = cloneDeep(setTo);
        this.gs.modified.item.MilestoneRewards = cloneDeep(this.milestoneRewards);
      }, 0);
    }, 0);
  }

  //Validate if rewards are already set
  rewardStepCompleted(): boolean {
    //iterate over milestone object
    for (var i = 0; i < this.gs.modified.item.MilestoneDetails.MilestoneQty; i++) {
      //Check Target
      switch (this.gs.modified.item.SelectedMetrics[0].direction) {
        case "1":// Greather
        case "2"://Less than
          if (this.milestoneRewards[i].Target.Val1 == undefined || this.milestoneRewards[i].Target.Val1 == null)
            return false;
          break;
        case "3":
          if ((this.milestoneRewards[i].Target.Val1 == undefined || this.milestoneRewards[i].Target.Val1 == null) && (this.milestoneRewards[i].Target.Val2 == undefined || this.milestoneRewards[i].Target.Val2 == null)) {
            return false;
          }
          break;
      }
      //Check if at least one of the reward types is filled out.
      if (this.milestoneRewards[i].Coins.rewardValue == null && this.milestoneRewards[i].XP.rewardValue == null && this.milestoneRewards[i].Badge.rewardValue == null)
        return false;
    }
    this.gs.modified.item.MilestoneRewards = cloneDeep(this.milestoneRewards);
    return true;
  }

  removeBadge (badge: any): void {
    badge.rewardValue = 0;
    this.gs.modified.item.MilestoneRewards = cloneDeep(this.milestoneRewards);
  }

  getPopoverTemplate(badgeID: number): string {
    return "<div class='glaeBadgePopover'><img src=\"../Admin/ImageResizer.aspx?imgid=" + badgeID + "&w=128&h=128\" /></div>"
  }

  checkForComponentCompletion (): void {
    if (!this.consideredComplete) {
      if (this.rewardStepCompleted()) {
        //Fire one time event to unlock the next component
        var eventArgs = {
          currentStep: this.step - 1,
          unlocks: 'next2'
        };
        
        this.consideredComplete = true;
        this.componentComplete.emit(eventArgs);
      }
    }
    this.gs.modified.item.MilestoneRewards = cloneDeep(this.milestoneRewards);
  }

  getCheckmark (index: number) {
    return { 'background-image': 'url(' + this.gs.modified.item.MilestoneDetails.MilestoneThemeSelected.themePath + "checkmark" + index + ".svg" + ')' }
  }

  indexSorting(){
    return this.milestoneRewards.sort((a: any, b: any) => (a.Index < b.Index) ? 1 : ((a.Index === b.Index) ? 0 : -1));
  }

  getFormattedMetric(value: number){
    if(value != null){      
      return this.metricPipe.transform(value, this.gs.modified.item.SelectedMetrics[0].conversionType);
    }
  }

  onKeyPressed(event: any){
    return event.charCode >= 48;
  }

  getLocalizationString(key: string, defaultValue: string) {
    return this.cvLocalizationService.getCachedText("Games", key, defaultValue);
}

  milestoneTargetTranslation(index: number): string {
    const template = this.getLocalizationString("Milestone_Target_Level", "Milestone {0} Target");
    return template.replace("{0}", index.toString());
  }
}
